
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface RequestsEmptyStateProps {
  onCreateNew: () => void;
}

const RequestsEmptyState: React.FC<RequestsEmptyStateProps> = ({ onCreateNew }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 text-center">
      <p className="text-gray-600 mb-4">{t('interview.noRequestsFound')}</p>
      <Button onClick={onCreateNew}>{t('interview.createNewRequest')}</Button>
    </div>
  );
};

export default RequestsEmptyState;
